<template>
    <div class="content-page" v-loading.fullscreen.lock="pageLoading">
        <div class="pc-header">
            <crumbs></crumbs>
        </div>
        <div class="mobile-header">
            <div class="top-header">
                <expandMenuIcon top="0.3rem"></expandMenuIcon>
                <img src="../../assets/image/xitong.png" alt="" />
            </div>
        </div>
        <dataCard :dataList="dataList"></dataCard>
        <!-- 客户统计 -->
        <h3 style="margin: 30px 0 20px 0;" v-if="productCountList.length">客户统计</h3>
        <div class="product-container">
            <div class="product-item" v-for="item in productCountList" :key="item.productId">
                <div class="name-line">
                    <div>
                        <img src="~@/assets/image/home/icon-ers.png" v-if="item.productId === '1'" />
                        <img src="~@/assets/image/home/icon-资源地图.png" v-else-if="item.productId === '2'" />
                        <img src="~@/assets/image/home/icon-科学平台.png" v-else-if="item.productId === '3'" />
                        <img src="~@/assets/image/home/icon-资源地图.png" v-else-if="item.productId === '10'" />
                    </div>
                    <div class="column">
                        <span class="cname">{{ item.remark }}</span>
                        <span class="ename">{{ item.engName }}</span>
                    </div>
                </div>
                <div class="count-list">
                    <div class="count" v-for="child in item.customerCountList" :key="child.orderType" @click="enterPage(item.productId, child.orderType)">
                        <span class="name">{{ child.name }}</span>
                        <span class="value">{{ child.value }}</span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 特殊事项 -->
        <SpecialMatter />
    </div>
</template>
<script>
import dataCard from "./components/dataCard.vue";
import {
    findVisitFrequencyListTop5,
    findVisitFrequencyListCount,
    findAccountExpirationListTop5,
    findAccountExpirationListCount,
    findProductCustomerCount,
} from "@/api/home/index.js";

export default {
    components: {
        dataCard,
        SpecialMatter: () => import('./components/SpecialMatter.vue'),
    },
    data() {
        return {
            pageLoading: false,
            dataList: [
                {
                    title: "拜访频率预警",
                    src: require("@/assets/image/baifang.png"),
                    errorTips: false,
                    totalNum: 0,
                    list: [],
                },
                {
                    title: "产品到期预警",
                    titleClick: true,
                    titlePath: '/customer?statusList=1',
                    src: require("@/assets/image/zhanghao.png"),
                    errorTips: true,
                    totalNum: 0,
                    list: [],
                },
                {
                    title: "合同到期提醒",
                    src: require("@/assets/image/daoqi.png"),
                    errorTips: true,
                    totalNum: 0,
                    list: [],
                },
                {
                    title: "合同未上传",
                    src: require("@/assets/image/weishangchuan.png"),
                    errorTips: true,
                    totalNum: 0,
                    list: [],
                },
                {
                    title: "回款预警",
                    src: require("@/assets/image/huikuan.png"),
                    errorTips: true,
                    totalNum: 0,
                    list: [],
                },
            ],
            // 客户统计
            productCountList: [],
        };
    },
    created() {
        this.initPage();
    },
    methods: {
        async initPage() {
            this.dataList.forEach((i) => (i.list = []));

            this.findVisitFrequencyListTop5Api();
            this.findVisitFrequencyListCountApi();

            this.findAccountExpirationListTop5Api();
            this.findAccountExpirationListCountApi();

            this.fetchProductCustomerCount();
        },

        // 拜访频率预警-查询前五
        findVisitFrequencyListTop5Api() {
            findVisitFrequencyListTop5()
                .then((res) => {
                    res.data.forEach((item) => {
                        this.dataList[0].list.push({
                            ...item,
                            des: item.value + "天未拜访",
                        });
                    });
                })
                .catch((err) => {
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },

        // 拜访频率 查询预警总数
        findVisitFrequencyListCountApi() {
            findVisitFrequencyListCount()
                .then((res) => {
                    this.dataList[0].totalNum = res.data;
                })
                .catch((err) => {
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },

        // 查询账号到期-查询前五
        findAccountExpirationListTop5Api() {
            findAccountExpirationListTop5()
                .then((res) => {
                    res.data.forEach((item) => {
                        this.dataList[1].list.push({
                            ...item,
                            des: item.value == 0 ? "今天到期" : "剩余" + item.value + "天",
                        });
                    });
                })
                .catch((err) => {
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },

        // 查询账号到期-查询总数
        findAccountExpirationListCountApi() {
            findAccountExpirationListCount()
                .then((res) => {
                    this.dataList[1].totalNum = res.data;
                })
                .catch((err) => {
                    this.$MessageBox.MessageWarning(err.data.msg);
                });
        },
        // 查询产品订购数量
        fetchProductCustomerCount() {
            findProductCustomerCount().then(res => {
                this.productCountList = [];
                res.data.forEach(item => {
                    let temp = { ...item };
                    temp.customerCountList.forEach(child => {
                        if (child.name.indexOf('订购') > -1) {
                            child.orderType = '1';
                        } else if (child.name.indexOf('合作') > -1) {
                            child.orderType = '4';
                        } else if (child.name.indexOf('试用') > -1) {
                            child.orderType = '0';
                        }
                    })
                    this.productCountList.push(temp);
                })
            }).catch(err => {
                this.productCountList = [];
                this.$MessageBox.MessageWarning(err.data.msg);
            });
        },
        enterPage(productId, orderType) {
            this.$router.push({
                path: '/customer',
                query: {
                    productId,
                    orderType,
                    statusList: '0,1'
                }
            });
        },
    },
};
</script>
<style lang="scss" scoped>
/*pc端*/
@media only screen and (min-width: 768px) {
    .content-page {
        width: 80%;
        margin: 0 auto;
        padding-top: $pc-header-height;
        min-height: calc(100vh - #{$pc-header-height});
        padding-bottom: 4rem;
        .mobile-header {
            display: none;
        }
    }
}
/*移动端*/
@media only screen and (max-width: 767px) {
    $top-header-height: 3.9rem;
    .content-page {
        padding: calc(#{$top-header-height} + 20px) 13px 40px;
        background-color: #f4f6fd;
        min-height: 100vh;
        .pc-header {
            display: none;
        }

        .top-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            background-color: #fff;
            height: $top-header-height;
            border-radius: 0 0 20px 20px;
            box-shadow: 0px 1px 12px 1px rgba(9, 16, 92, 0.08);
            @include bothCenter;
            z-index: 99;

            img {
                width: 100px;
                height: 25px;
            }
        }
    }
    .product-container {
        display: block !important;
        .product-item {
            width: 100% !important;
            margin-bottom: 1rem;
        }
    }
}
.content-page {
    color: $primary-font-color;
}

.product-container {
    display: flex;
    flex-wrap: wrap;
    gap: 1.6rem;
    .product-item {
        display: flex;
        flex-direction: column;
        gap: 5%;
        width: calc(100% / 4 - 1.2rem);
        padding: 1.5rem 2rem;
        background-color: #fff;
        border-radius: 12px;
        box-shadow: 0px 1px 0.75rem 1px rgba(4, 32, 93, 0.09);
        box-sizing: border-box;
        .name-line {
            display: flex;
            img {
                width: 3rem;
                margin-right: 1rem;
            }
            .column {
                display: flex;
                flex-direction: column;
                gap: 0.1rem;
                .cname {
                    font-size: 1.1rem;
                    font-weight: 550;
                }
                .ename {
                    font-size: 0.8rem;
                    color: #6c6c6c;
                }
            }
        }
        .count-list {
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
            margin-top: 15px;
            border-top: 1px dashed #ddd;
            .count {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
                cursor: pointer;
                white-space: nowrap;
                .name {
                    color: #999;
                    font-weight: 400;
                    font-size: 0.8rem;
                }
                .value {
                    color: $primary-btn-color;
                    font-size: 1.3rem;
                    font-weight: 600;
                }
            }
        }
    }
}
</style>
